import React from 'react'

export default function IconThreeCol({ colour = 'currentColor', ...rest }) {
    return (
        <svg
            preserveAspectRatio='none'
            width='264'
            height='24'
            viewBox='0 0 264 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            {...rest}
        >
            <path
                d='M12 0.5H81.333C83.266 0.5 84.833 2.067 84.833 4V20C84.833 21.933 83.266 23.5 81.333 23.5H12C10.067 23.5 8.5 21.933 8.5 20V4C8.5 2.067 10.067 0.5 12 0.5Z'
                fill='#EEEEED'
            />
            <path
                d='M12 0.5H81.333C83.266 0.5 84.833 2.067 84.833 4V20C84.833 21.933 83.266 23.5 81.333 23.5H12C10.067 23.5 8.5 21.933 8.5 20V4C8.5 2.067 10.067 0.5 12 0.5Z'
                stroke='#E1E1E0'
            />
            <path
                d='M97.333 0.5H166.666C168.599 0.5 170.166 2.067 170.166 4V20C170.166 21.933 168.599 23.5 166.666 23.5H97.333C95.4 23.5 93.833 21.933 93.833 20V4C93.833 2.067 95.4 0.5 97.333 0.5Z'
                fill='#EEEEED'
            />
            <path
                d='M97.333 0.5H166.666C168.599 0.5 170.166 2.067 170.166 4V20C170.166 21.933 168.599 23.5 166.666 23.5H97.333C95.4 23.5 93.833 21.933 93.833 20V4C93.833 2.067 95.4 0.5 97.333 0.5Z'
                stroke='#E1E1E0'
            />
            <path
                d='M182.667 0.5H252C253.933 0.5 255.5 2.067 255.5 4V20C255.5 21.933 253.933 23.5 252 23.5H182.667C180.734 23.5 179.167 21.933 179.167 20V4C179.167 2.067 180.734 0.5 182.667 0.5Z'
                fill='#EEEEED'
            />
            <path
                d='M182.667 0.5H252C253.933 0.5 255.5 2.067 255.5 4V20C255.5 21.933 253.933 23.5 252 23.5H182.667C180.734 23.5 179.167 21.933 179.167 20V4C179.167 2.067 180.734 0.5 182.667 0.5Z'
                stroke='#E1E1E0'
            />
        </svg>
    )
}
